import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ReactModal from 'react-modal';
import Select from 'react-select';
import Toggle from 'react-toggle';
import styled from "styled-components";
import { ValueLabel, BenchYear_Schools, FilterAction, FilterUserState, SpendingReportAction } from '../../../interface/MyInterfaces'

import ReactTooltip from 'react-tooltip';

import { closeFilter, filterItemsLoading, handleStartYearChange, handleEndYearChange, handleInputChange, handleWorkStudyChange, handleAggregateChange, handleNegativeChange, handleBenchYearChange, handleBenchSchoolsChange, getAggSchools } from '../../../actions/FilterPageActions';
import { loadSpendingReport } from '../../../actions/SpendingReportActions';
import { addTriggeredEvent } from '../../../actions/UserActions';
import { isAgg } from '../../Common/Helpers';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../reducers/Index';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const aggTooltip = "This toggle will create a new page within the report that aggregates data together for all the selected benchmarking universities and your university combined.";
const negativeTooltip = "These are payments that have been received back from vendors or subawardees.";
const benchmarkingTooltip = "This report allows you to benchmark your institution's in-state spending against a peer group of your selection.<br/>  Our system defaults to the most recent year for which data have been provided to IRIS. You may select other <br/>benchmarking years depending upon your needs and available data. You may de-select universities in order to <br/>customize benchmarking but a minimum of 3 institutions must be chosen to protect confidentiality.";

class Filter extends React.Component<FilterUserState & FilterAction & SpendingReportAction, {}> {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.mustBeAtLeastTen = this.mustBeAtLeastTen.bind(this);
    }
    handleSubmit() {
        if (this.props.closeFilter !== undefined) {
            //let bench_school_ids = this.props.FilterState.bench_schools.map((x) => { return x.value });
            this.props.closeFilter(this.props.FilterState.hide_error);
            //submissionTime is used in the header text ...is based on UMETRICS data submitted to IRIS as of submissionTime"
            const { submission_month_year: submissionTime } = this.props.UserState.UniversityListSpendingReport.filter(u => u.display_id == this.props.UserState.report_display_id)[0];
            const agg = isAgg(this.props.UserState.report_display_id);
            const workStudyFlag = agg ? 0 : (this.props.FilterState.work_study ? 1 : 0);
            this.props.loadSpendingReport(
                this.props.FilterState.Initial_the_university,
                this.props.UserState.report_display_id,
                "f",
                this.props.FilterState.start_year,
                this.props.FilterState.end_year,
                this.props.FilterState.report_type,
                workStudyFlag,
                this.props.FilterState.aggregate ? 1 : 0,
                this.props.FilterState.negative ? 1 : 0,
                this.props.FilterState.bench_year,
                this.props.FilterState.bench_schools,
                this.props.FilterState.agg_schools,
                this.props.UserState.report_vintage_spending,
                submissionTime
            );
            // log spending report filter change
            this.props.addTriggeredEvent("Spending Report", this.props.UserState.username, this.props.UserState.display_id, "customized report with filter");
        }
    }
    componentDidMount() {
        if (this.props.filterItemsLoading !== undefined) {
            this.props.filterItemsLoading(this.props.UserState.report_display_id, this.props.UserState.report_vintage_spending);
        }
    }
    BenchSchoolOptions(bench_year) {
        var i;
        if (this.props.FilterState.Initial_bench_years !== undefined && this.props.FilterState.Initial_bench_years != null) {
            for (i = 0; i < this.props.FilterState.Initial_bench_years.length; i++) {
                if (this.props.FilterState.Initial_bench_years[i] !== undefined) {
                    if (this.props.FilterState.Initial_bench_years[i].year == bench_year) {
                        return this.props.FilterState.Initial_bench_years[i].schools;
                    }
                }
            }
        }
    }

    DataForYearFound(the_year) {
        let index = this.props.FilterState.Initial_exact_years.indexOf(the_year.toString());
        
        if (this.props.FilterState.Initial_exact_years !== undefined
            && (index == -1)) return true;
        return false;
    }

    IsWorkStudyDisabled() {
        if (this.props.FilterState.Initial_work_study == " and 1=1") return true;
        return false;
    }

	getYearList() {
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();
        let start_here: any, end_here: any;
        if (this.props.FilterState.Initial_date1 !== undefined && this.props.FilterState.Initial_date1 != null) {
            start_here = +this.props.FilterState.Initial_date1;
            if (this.props.FilterState.Initial_date2 !== undefined && this.props.FilterState.Initial_date2 != null)
                end_here = this.props.FilterState.Initial_date2;

            for (let i = end_here; i >= start_here; i--) {
				the_list.push({ value: i, label: i, isDisabled: this.DataForYearFound(i) });
            }
        }
        return the_list;
    }

    getBenchList() {
        var i;
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();
        if (this.props.FilterState.Initial_bench_years !== undefined) {
            for (i = 0; i < this.props.FilterState.Initial_bench_years.length; i++) {
                if (this.props.FilterState.Initial_bench_years[i] !== undefined) {
                    let by = this.props.FilterState.Initial_bench_years[i].year;
                    the_list.push({ value: by, label: String(by) })
                }
            }
        }



        return the_list.sort((a, b) => b.value - a.value)
    }

    getSelectedBenchSchools() {
        return this.props.FilterState.bench_schools;
    }

    mustBeAtLeastTen(event) {
        if (event.length >= 3) {
            this.props.handleBenchSchoolsChange(event)
        }
    }

    public render() {
		let start_year_options = this.getYearList();
		let end_year_options = this.getYearList();
        let bench_year_options = this.getBenchList();
        const agg = isAgg(this.props.UserState.report_display_id);
        if (this.props.FilterState.Initial_bench_years === undefined) {
            return <ReactModal
                isOpen={true}
                className="Modal"
                overlayClassName="Overlay"
                ariaHideApp={false}>
                <h1>loading <i className="fa fa-spinner"></i></h1>
                <p>loading <i className="fa fa-spinner"></i></p>
            </ReactModal>
        } else {
            var set_start_year;

            if (this.props.FilterState.start_year !== undefined && this.props.FilterState.start_year !== null) {
                set_start_year = this.props.FilterState.start_year.toString()
            }
          
            const school = this.props.FilterState.Initial_the_university && this.props.FilterState.Initial_the_university.charAt(0).toUpperCase() + this.props.FilterState.Initial_the_university.slice(1);
            console.log(this.props.FilterState)
            const workStudyDisabled = agg || this.IsWorkStudyDisabled();
            const workStudyChecked = agg ? false : this.props.FilterState.work_study;
            return (
                <ReactModal
                    isOpen={this.props.FilterState.showModal}
                    className="Modal"
                    overlayClassName="Overlay"
                    style={{
                        overlay: {
                            height: '100%'
                        },
                        content: {
                            overflow: 'scroll',
                            height: '100%'
                        }
                    }}
                    ariaHideApp={false}>
                    <h1><span>{school}</span></h1>
                    <h2>Welcome to {school} Spending Report.</h2>
                    <h3> (Customize your university report).</h3>
                    <form>
                        <span>This report is based on your institution's fiscal year. If you need a report based on a calendar year please contact us. To generate a report for a single fiscal year select that year as both your start year and end year. To generate a report for multiple fiscal years, select the appropriate year ranges.</span>
                        <fieldset className="fieldset_startendyear margintop">
                            <span className="startendyear">Start Year</span>
                            <Select id="start-year-dropdown" className="filterdropdown startendyeardd" name="start_year"
                                value={{
                                    label: set_start_year,
                                    value: this.props.FilterState.start_year
                                }}
                                onChange={this.props.handleStartYearChange}
                                options={start_year_options}
                            />
                            {!this.props.FilterState.hide_error && <label className="filterError">The start year must be earlier than the end year</label>}
                        </fieldset>
                        <fieldset className="fieldset_startendyear">
                            <span className="startendyear">End Year</span>
                            <Select id="end-year-dropdown" className="filterdropdown startendyeardd" name="end_year"
                                value={{ label: this.props.FilterState.end_year.toString(), value: this.props.FilterState.end_year }}
                                onChange={this.props.handleEndYearChange}
                                options={end_year_options}
                            />
                            {!this.props.FilterState.hide_error && <label className="filterError">The start year must be earlier than the end year</label>}
                        </fieldset>
                        <fieldset className="fieldset_startendyear">
                            <span className={(workStudyDisabled ? 'disabled_span' : '')}>Include work-study data?</span>
                            <Toggle
                                className="mytoggle"
                                name="work_study"
                                aria-label="Should include work study data?" 
                                disabled={workStudyDisabled}
                                defaultChecked={workStudyChecked}
                                onChange={this.props.handleWorkStudyChange} />
                            <p className={(workStudyDisabled ? '' : 'display_none')}>
                                {agg
                                    ? "This option is unavailable for aggregate reports."
                                    : "This option is unavailable because this university's work study data could not be identified. Please contact IRIS if you would like this option activated."}
                            </p>
                        </fieldset>
                        <fieldset>
                            <span>Report Type</span>
                            <div className="radio">
                                <label>
                                    <input aria-label="federal" name="report_type" type="radio" value="federal" checked={this.props.FilterState.report_type === "federal"} onChange={this.props.handleInputChange} />
                                    Federal
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input aria-label="all" name="report_type" type="radio" value="all" checked={this.props.FilterState.report_type === "all"} onChange={this.props.handleInputChange} />
                                    All
                                </label>
                            </div>
                        </fieldset>
                        <fieldset className="fieldset_startendyear">
                            <span>Include negative payments?</span>
                            <Toggle
                                className="mytoggle"
                                name="negative"
                                aria-label="should include negative payments?" 
                                defaultChecked={this.props.FilterState.negative}
                                onChange={this.props.handleNegativeChange}
                            />
                            <p>These are payments returned to your institution from vendors or sub-awardees.</p>
                        </fieldset>
                        {!agg && this.props.FilterState.bench_year &&
                            <fieldset style={{ minHeight: 'auto' }}>
                                <span>Benchmark Year</span>
                                <Select className="filterdropdown startendyeardd" name="bench_year"
                                    value={{ label: this.props.FilterState.bench_year.toString(), value: this.props.FilterState.bench_year }}
                                    onChange={this.props.handleBenchYearChange}
                                    options={bench_year_options}
                                />
                            </fieldset>
                        }
                        <fieldset style={{ display: agg ? 'none' : 'block' }}>
                            <span className="filterdropdown_bench">
                                Benchmark universities
                            </span>
                            <p>Select no fewer than three universities from this list to create a benchmark group against which your institution’s in-state spending can be compared. If you prefer not to benchmark your data in the most recent year available, you can choose another benchmark year from the drop-down menu above</p>
                            <Select className="filterdropdown_bench" name="bench_schools" value={this.getSelectedBenchSchools()}
                                onChange={this.mustBeAtLeastTen}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                options={this.BenchSchoolOptions(this.props.FilterState.bench_year)}

                            />
                        </fieldset>

                        <button aria-label="Submit" className="btn-primary filterButton" type="button" onClick={() => this.handleSubmit()}>Submit</button>
                    </form>
                </ReactModal>
            );
        }
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            closeFilter: closeFilter,
            filterItemsLoading: filterItemsLoading,
            handleStartYearChange: handleStartYearChange,
            handleEndYearChange: handleEndYearChange,
            handleInputChange: handleInputChange,
            handleWorkStudyChange: handleWorkStudyChange,
            handleAggregateChange: handleAggregateChange,
            handleNegativeChange: handleNegativeChange,
            handleBenchYearChange: handleBenchYearChange,
            handleBenchSchoolsChange: handleBenchSchoolsChange,
            loadSpendingReport: loadSpendingReport,
            addTriggeredEvent: addTriggeredEvent
        }, dispatch
    )
}

const mapStateToProps_FilterAndUser = (state: ApplicationState) => ({
    FilterState: state.filterProperties,
    UserState: state.userProperties
});


export default connect(
    mapStateToProps_FilterAndUser, // Selects which state properties are merged into the component's props
    matchDispatchToProps
)(Filter);
